import { render, staticRenderFns } from "./reldemonstrativolancamento.vue?vue&type=template&id=c8b33700"
import script from "./reldemonstrativolancamento.vue?vue&type=script&lang=js"
export * from "./reldemonstrativolancamento.vue?vue&type=script&lang=js"
import style0 from "./reldemonstrativolancamento.vue?vue&type=style&index=0&id=c8b33700&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports